import { FIND_ASSIGNABLE_ASSET_ROUTINES } from '@gripp/shared-logic';
import { AssignmentListGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoutineColumns } from '../../new-routines/components/useRoutineColumns';

export type EditAssetRoutinesListProps = {
  workspaceId: string;
  assetId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const EditAssetRoutinesList = ({
  workspaceId,
  assetId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: EditAssetRoutinesListProps) => {
  const { t } = useTranslation();
  const filter = useMemo(() => {
    if (!workspaceId) return undefined;
    
    return {
      keyword,
      assetId,
      routines: assignments,
      workspaceId,
    };
  }, [keyword, assetId, workspaceId]);
  
  const columns = useRoutineColumns() as ColumnDef<any, any>[];

  if (!filter) return null;

  return (
    <AssignmentListGrid
      modelName="routine"
      query={FIND_ASSIGNABLE_ASSET_ROUTINES}
      dataPrefix="routine.findAssignableAssetRoutines"
      columns={columns}
      filter={filter}
      assignments={assignments}
      onAssignmentsChange={updateAssignments}
      maxHeight={maxHeight}
      textEmpty={t('routines.textEmpty')}
      orderBy={{ field: 'name', order: 'ASC' as any }}
    />
  );
};
